<script>
import Layout from '@layouts/overview.vue'
import { mapActions } from 'vuex'
import ClientOverviewTable from '@/components/client/client-overview-table.vue'

export default {
  name: 'ClientOverviewView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Client Overview page.' }],
    }
  },
  components: { Layout, ClientOverviewTable },
  methods: {
    ...mapActions({
      setClient: 'client/setClient',
    }),
    async selectClient(row) {
      const result = await this.setClient(row.clientId)
      if (result.isSuccess) this.$router.push({ name: 'home' })
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageTitle
      :title="$t('clientOverview.pageTitle')"
      :subtitle="$t('clientOverview.subTitle')"
    />

    <ClientOverviewTable @selectClient="selectClient" />
  </Layout>
</template>
